import React from "react";
import { CredentialProps } from "../CredentialProps";
import { CredentialLayout } from '../CredentialLayout';
import { CredentialEntities } from "../CredentialEntities";
import { NSARouterMakerResult } from "namirasoft-account-react";

interface AzureListPageProps extends NSARouterMakerResult, CredentialProps { }

export default class AzureListPage extends React.Component<AzureListPageProps>
{
	override render()
	{
		return (
			<CredentialLayout
				{...this.props}
				action={{
					description: "This section lists all the Microsoft Azure credentials saved in your workspace, showing each one's name and identifiers. You can open, copy, edit, or delete any entry, review its change history, or create a new one.",
				}}
				pages={{
					entity: CredentialEntities.azure(this.props),
					list: {
						ui: {}
					}
				}}
			>
				<></>

			</CredentialLayout >
		);
	}
}